import Image from 'components/Image';
import Link from 'components/Link';
import useElementOnScreenCallback from 'hooks/useElementOnScreenCallback';
import styles from './PromotionTile.module.scss';

const LUME_CANNABIS_CO = 'Lume Cannabis Co.';

export default function PromotionTile({
  backgroundImage,
  handleObserved,
  linkHref,
  linkText,
  priority,
  subtitle,
  text,
  title,
}) {
  const tileRef = useElementOnScreenCallback(handleObserved);

  return (
    /* eslint-disable-next-line jsx-a11y/no-redundant-roles */
    <li
      ref={tileRef}
      className="p-0 position-relative"
      role="listitem"
      data-value="promotion-tile"
    >
      <div className="w-100 h-100 overflow-hidden position-relative">
        <Image
          fill
          alt={`Background for ${title}`}
          objectFit="cover"
          priority={priority}
          quality={70}
          role="presentation"
          sizes="(max-width: 992px) 50vw, 25vw"
          src={backgroundImage}
        />
      </div>
      <div className={`position-absolute h-100 w-100 ${styles.text_container}`}>
        <div className="d-flex flex-column h-100">
          <div className="my-auto p-10">
            <h3 className="font-sofia fs-6 fs-sm-7 mb-6 mb-sm-7 text-uppercase text-white">
              {subtitle || LUME_CANNABIS_CO}
            </h3>
            <h2 className="font-frl fs-12 fs-sm-14 fs-xl-16 mb-15 lh-1 text-white">
              {title}
            </h2>
            <p className="fs-6 fs-md-7 fs-xl-8 mb-15 text-white">{text}</p>
            <Link href={linkHref} className="btn btn-secondary fs-7">
              {linkText}
            </Link>
          </div>
        </div>
      </div>
    </li>
  );
}
